import { currentSearchTerm } from './state.js';

export function highlightSearchTerm(text: string, term: string = currentSearchTerm): string {
    if (!term || !text) return text;

    const escapeHtml = (str: string) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedTerm, 'gi');

    const parts: string[] = [];
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(escapeHtml(text.substring(lastIndex, match.index)));
        }
        parts.push('<strong>' + escapeHtml(match[0]) + '</strong>');
        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
        parts.push(escapeHtml(text.substring(lastIndex)));
    }

    return parts.length > 0 ? parts.join('') : escapeHtml(text);
}
